document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.announcement-bar');
    const items = wrapper?.querySelectorAll('.top-item') || [];
    const speedAttr = wrapper?.getAttribute('data-speed');
    const intervalTime = (parseFloat(speedAttr) || 5) * 1000;

    let activeIndex = 0;

    if (items.length > 1) {
        items[0].classList.add('active');

        setInterval(() => {
            const current = items[activeIndex];
            const nextIndex = (activeIndex + 1) % items.length;
            const next = items[nextIndex];

            current.style.transition = 'none';
            current.classList.remove('active');

            void current.offsetWidth;
            current.style.transition = '';

            next.classList.add('active');
            activeIndex = nextIndex;
        }, intervalTime);
    }
});
